// extracted by mini-css-extract-plugin
export default {"hamburger":"Hamburger_hamburger__uWEyL","burger":"Hamburger_burger__UYf3Q"};